type HistoryReviewInput = {
  transcript: string | null;
  /** `structured` vem do banco como Json: pode ser `{}`, `[]` ou null quando a IA nao rodou. */
  structured: unknown;
  summary: string | null;
  aiStatus: string | null;
  captureStatus: string | null;
};

type HistoryReviewDecision = {
  action: "none" | "extract";
  reason:
    | "empty_transcript"
    | "already_processing"
    | "already_structured"
    | "missing_structured"
    | "capture_not_finalized";
};

const hasStructuredContent = (structured: unknown): boolean => {
  if (!structured || typeof structured !== "object") return false;
  return Object.keys(structured as Record<string, unknown>).length > 0;
};

/**
 * Decide o que fazer ao reabrir um item do historico. O caminho comum e um
 * registro cuja transcricao gravou mas a estruturacao falhou (erro do provedor
 * de IA): abrir sem reprocessar deixaria a ficha vazia e sem saida na UI.
 */
export const decideHistoryReview = ({
  transcript,
  structured,
  summary,
  aiStatus,
  captureStatus,
}: HistoryReviewInput): HistoryReviewDecision => {
  if (!transcript?.trim()) return { action: "none", reason: "empty_transcript" };
  if (aiStatus === "processing") return { action: "none", reason: "already_processing" };
  if (hasStructuredContent(structured) || summary?.trim()) {
    return { action: "none", reason: "already_structured" };
  }
  if (captureStatus !== "finalized") {
    // Captura ainda em andamento: o backend recusaria a extracao. Nao e o caso
    // do historico revisado (esses ja encerraram), mas a guarda evita a chamada.
    return { action: "none", reason: "capture_not_finalized" };
  }
  return { action: "extract", reason: "missing_structured" };
};
